import React from "react"

export const VideoModal = ({ params }) => (
    <>
      <div className="video-container">
        <video
          id="video"
          className="video"
          src={params.source.src}
          controls
        ></video>
        <div className="video-info">
          <p className="text-center">{params.source.metadata.width} x {params.source.metadata.height}</p>
        </div>
      </div>
      <div className="button-wrapper">
        <button className="text-center btn col-4" onClick={params.onCancel}>
          Ok
        </button>
      </div>
    </>
)
